export interface AppContextProps {
    routing: Routing;
    showModal: boolean;
    selectedIndustry: Industries | null;
    selectedPOSSolution: POSSolution | null;
    selectedContractDuration: ContractDuration;
    sites: Site[];
    sitesTotal: number;
    isNewSite: boolean;
    selectedSiteFlow: number;
    flowDevices: Device[];
    flowAccessories: CartItem[];
    flowCardMachines: CardMachine[];
    selectedDeliveryPackage: DeliveryPackage | null;
    selectedProductConfPackage: ProductConfPackage | null;
    selectedOngoingSupportPackage: OngoingSupportPackage | null;
}
export enum Routing {
    Epos,
    Terminals,
    EposByIndustry,

}

export enum ProductTypes {
    Epos = "EPOS",
    Terminals = "TERMINALS",
    Accesories = "ACCESSORIES",
}

export enum ContractDuration {
    twoYears = "24 Months",
    threeYears = "36 Months",
}

export enum PaymentFrequency {
    Monthly = "monthly",
    Single = "one-off",
}

export interface Product {
    id: number;
    name: string;
    prices: {
        [ContractDuration.twoYears]: number;
        [ContractDuration.threeYears]: number;
    };
    imageUrl: string;
    type: ProductTypes;
    description: string;
    paymentFrequency: PaymentFrequency;
}

export const accessories: Product[] = [
    {
        id: 1,
        name: "Receipt Printer",
        prices: {
            [ContractDuration.twoYears]: 14.5,
            [ContractDuration.threeYears]: 10,
        },
        imageUrl: "https://npi.ie/wp-content/uploads/2023/12/printer.png",
        type: ProductTypes.Accesories,
        description: `With rapid printing speeds and precision, the printer ensures quick and accurate receipt generation.`,
        paymentFrequency: PaymentFrequency.Monthly,
    },
    {
        id: 2,
        name: "Cash Drawer",
        prices: {
            [ContractDuration.twoYears]: 5.0,
            [ContractDuration.threeYears]: 3.0,
        },
        imageUrl: "https://npi.ie/wp-content/uploads/2023/12/cash-draw.png",
        type: ProductTypes.Accesories,
        description: `Crafted with durability and functionality in mind, this cash drawer seamlessly integrates with your Sunmi EPOS system.`,
        paymentFrequency: PaymentFrequency.Monthly,
    },
    {
        id: 3,
        name: "Barcode Scanner",
        prices: {
            [ContractDuration.twoYears]: 5.0,
            [ContractDuration.threeYears]: 3.5,
        },
        imageUrl: "https://npi.ie/wp-content/uploads/2023/12/scanner.png",
        type: ProductTypes.Accesories,
        description: `A powerful and versatile device designed to enhance your business's scanning and data collection capabilities.`,
        paymentFrequency: PaymentFrequency.Monthly,
    },
];

export interface CardMachine extends Product {
    hasLicence?: boolean;
    licenceFee: number;
}
export const cardMachines: CardMachine[] = [
    {
        id: 4,
        name: "Pax A50",
        prices: {
            [ContractDuration.twoYears]: 12,
            [ContractDuration.threeYears]: 10,
        },
        imageUrl: "https://npi.ie/wp-content/uploads/2023/12/pax150.png",
        type: ProductTypes.Terminals,
        description: `Similar in size to a smartphone, this compact card machine processes transactions quickly and is simple to use.`,
        paymentFrequency: PaymentFrequency.Monthly,
        hasLicence: false,
        licenceFee: 0
    },
    {
        id: 5,
        name: "Pax A920 pro",
        prices: {
            [ContractDuration.twoYears]: 18,
            [ContractDuration.threeYears]: 15,
        },
        imageUrl: "https://npi.ie/wp-content/uploads/2023/12/paxa920.png",
        type: ProductTypes.Terminals,
        description: `Robust and anti-fall card machine, designed for crowded events.`,
        paymentFrequency: PaymentFrequency.Monthly,
        hasLicence: false,
        licenceFee: 0
    },
];

export interface Device extends Product {
    cardMachine: CardMachine | null;
    licenceFee: number;
}

export const epos: Device[] = [
    {
        id: 6,
        name: "SAMSUNG TABLET A8 + printer",
        prices: {
            [ContractDuration.twoYears]: 29.0,
            [ContractDuration.threeYears]: 19.5,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl:
            "https://npi.ie/wp-content/uploads/2023/11/SAMSUNG_A8_PRINTER.png",
        type: ProductTypes.Epos,
        description: `The ultra-slim Galaxy design offers a sleek and modern solution, ideal for maximizing space and efficiency.`,
        cardMachine: null,
        licenceFee: 0,
    },
    {
        id: 7,
        name: "SUNMI D2 MINI",
        prices: {
            [ContractDuration.twoYears]: 29.0,
            [ContractDuration.threeYears]: 19.5,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl: "https://npi.ie/wp-content/uploads/2023/11/SUNMI-MINI.png",
        type: ProductTypes.Epos,
        description: `The Sunmi D2 Mini is equipped to handle the demands of your business, providing a centralized hub for sales management.`,
        cardMachine: null,
        licenceFee: 0,
    },
    {
        id: 8,
        name: "SUNMI D2S Lite (+ printer)",
        prices: {
            [ContractDuration.twoYears]: 47.0,
            [ContractDuration.threeYears]: 31.5,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl:
            "https://npi.ie/wp-content/uploads/2023/11/SUNMI_D2S_LITE_PRINTER.png",
        type: ProductTypes.Epos,
        description: `All-in-one EPOS solution that combines the functionality of a touch monitor with an external printer.`,
        cardMachine: null,
        licenceFee: 0,
    },
    {
        id: 9,
        name: "SUNMI D2S 15.62 w/ printer",
        prices: {
            [ContractDuration.twoYears]: 40.5,
            [ContractDuration.threeYears]: 27.0,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl: "https://npi.ie/wp-content/uploads/2023/11/SUNMI-D2S-15-62.png",
        type: ProductTypes.Epos,
        description: `Its modern design and integrated printer make it a sophisticated choice for retailers, cafes, and more.`,
        cardMachine: null,
        licenceFee: 0,
    },
    {
        id: 10,
        name: "SUNMI D2S Lite (15+10) (+printer)",
        prices: {
            [ContractDuration.twoYears]: 54.0,
            [ContractDuration.threeYears]: 36.0,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl:
            "https://npi.ie/wp-content/uploads/2023/11/sunmi_d2s_lite_15_10_printer.png",
        type: ProductTypes.Epos,
        description: `Featuring two screens – one for customers and one for merchants – this sleek device takes your point-of-sale experience to the next level.`,
        cardMachine: null,
        licenceFee: 0
    },
    {
        id: 11,
        name: "SUNMI D2S (15+10) w/ printer",
        prices: {
            [ContractDuration.twoYears]: 48.5,
            [ContractDuration.threeYears]: 32.5,
        },
        paymentFrequency: PaymentFrequency.Monthly,
        imageUrl:
            "https://npi.ie/wp-content/uploads/2023/11/sunmi-d2s-1510printer.png",
        type: ProductTypes.Epos,
        description: `Featuring two screens + integrated printer – an advanced EPOS solution designed to revolutionize customer and merchant interactions.`,
        cardMachine: null,
        licenceFee: 0
    },
];

export type CartItem = Device | CardMachine | Product;

export interface Site {
    name: string;
    cart: CartItem[];
}

export enum Industries {
    Bakery = "Bakery",
    PubBar = "Pub / Bar",
    Restaurant = "Restaurant",
    SmallCoffee = "Cafe",
    Hotels = "Hotels",
    Convenience = "Convenience",
    Store = "Store",
    Hairdresser = "Hairdresser",
    Barber = "Barber",
    Spa = "Spa",
    NailTechnician = "Nail Technician",
    Doctor = "Doctor",
    Dentist = "Dentist",
    Lab = "Medical Lab",
    Custom = "None of These",
}

export enum DeliveryPackageNames {
    essential = "Essential",
    complete = "Complete",
    allInOne = "All-In-One",
    buildYourOwn = "Build Your Own"
}

export enum DeliveryChannels {
    courierShipping = "Courier Shipping",
    onSite = "Onsite delivery & Installation across ROI",
    custom = "As per quotation"
}

export interface DeliveryPackage {
    packageName: DeliveryPackageNames;
    price: number;
    priceDescription: string;
    description: string;
    recommended: boolean;
    paymentFrequency: PaymentFrequency;
    deliveryChannel: DeliveryChannels;
}

export const deliveryPackages: DeliveryPackage[] = [
    {
        packageName: DeliveryPackageNames.essential,
        price: 0,
        priceDescription: `FREE`,
        description: `Self set up instruction.
                        Online software how to guides & videos.
                        30 mins online activation training session**.
                        Email Support.​`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Single,
        deliveryChannel: DeliveryChannels.courierShipping,
    },
    {
        packageName: DeliveryPackageNames.complete,
        price: 299.99,
        priceDescription: `€299.99 per site.
                        €74.99 per hour after 1.5 hours on site.
                        `,
        description: `1 x site Installation visit.
                    Installation and set up for up to 3 devices or less.
                    30 mins in person activation training session.
                    Email Support.​`,
        recommended: true,
        paymentFrequency: PaymentFrequency.Single,
        deliveryChannel: DeliveryChannels.onSite,
    },
    {
        packageName: DeliveryPackageNames.allInOne,
        price: 719.99,
        priceDescription: `€719.99 per site.
                        €74.99 per hour after 5 hours on site.
                        `,
        description: `1 x site Installation visit.
                    Installation and set up for up to 4 devices or more.
                    30mins in person activation training session.
                    Email Support.`,
        recommended: true,
        paymentFrequency: PaymentFrequency.Single,
        deliveryChannel: DeliveryChannels.onSite,
    },
    {
        packageName: DeliveryPackageNames.buildYourOwn,
        price: 0,
        priceDescription: `As per quotation`,
        description: `Custom package to support unique needs. Choose this option and a member of our team will contact you to discuss your case.`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Single,
        deliveryChannel: DeliveryChannels.custom,
    },
];

export enum ProductConfNames {
    basic = "Basic",
    advanced = "Advanced",
    preciseTuning = "Precise Tuning",
    buildYourOwn = "Build Your Own",
}

export interface ProductConfPackage {
    packageName: ProductConfNames;
    price: number;
    description: string;
    recommended: boolean;
    paymentFrequency: PaymentFrequency;
}

export const productConfPackages: ProductConfPackage[] = [
    {
        packageName: ProductConfNames.basic,
        price: 0,
        description: `3 levels of tax set up (23%,13.5%,0%).
                        1 supervisor user & 1 general user.
                        Up to 1 hours Product set up (Including: Up to 10 products)  .                      
                        1 x 30 mins online* Online help guides​.`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Single,
    },
    {
        packageName: ProductConfNames.advanced,
        price: 150,
        description: `3 levels of tax set up (23%,13.5%,0%).
                        2 supervisor user & Up to 10 general user.
                        Up to 4 hours Product set up (Including: Up to 100 products, including modifiers, add store, other general settings & testing across devices).
                        1 x 1 hour online training session.`,
        recommended: true,
        paymentFrequency: PaymentFrequency.Single,
    },
    {
        packageName: ProductConfNames.preciseTuning,
        price: 300,
        description: `3 levels of tax set up (23%,13.5%,0%).
                        Unlimited supervisor user and general user.
                        Up to 6 hours Product set up (Including: Up to 300 products, including modifiers, add store, other general settings & testing across devices).
                        2 x 1 hours online training session.
                        (can be spilt into smaller sessions).`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Single,
    },
    {
        packageName: ProductConfNames.buildYourOwn,
        price: 0,
        description: `Custom package to support unique needs.
                        The price depends on your location. Please continue so we can get your contact details.`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Single,
    },
];

export enum OngoingSupportNames {
    standard = "Standard",
    premium = "Premium",
    elite = "Elite",
    buildYourOwn = "Build Your Own",
}

export interface OngoingSupportPackage {
    packageName: OngoingSupportNames;
    getPrice: (number: number) => number;
    calculatedPrice: number;
    description: string;
    recommended: boolean;
    paymentFrequency: PaymentFrequency;
}

export const ongoingSupportPackages: OngoingSupportPackage[] = [
    {
        packageName: OngoingSupportNames.standard,
        getPrice: (number) => 0,
        calculatedPrice: 0,
        description: `Email Communication (via customer services).
                        Error handling.
                        Query management.
                        Troubleshooting.
                        Online how to self-help guides.​`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Monthly,
    },
    {
        packageName: OngoingSupportNames.premium,
        getPrice: (number) =>
            number <= 2 ? 30 : number >= 3 && number <= 6 ? 40 : 55,
        calculatedPrice: 0,
        description: `Email & Telephonic communication.
                        Error handling.
                        Query management.
                        Troubleshooting.
                        5 hours per year of product configuration maintenance.
                        Online how to self-help guides.`,
        recommended: true,
        paymentFrequency: PaymentFrequency.Monthly,
    },
    {
        packageName: OngoingSupportNames.elite,
        getPrice: (number) =>
            number <= 2 ? 60 : number >= 3 && number <= 6 ? 70 : 85,
        calculatedPrice: 0,
        description: `Email, Telephonic communication & 1 visit to each site per year.
                        Error handling.
                        Query management.
                        Troubleshooting.
                        10 hours per year of product configuration maintenance.
                        Online how to self-help guides.`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Monthly,
    },
    {
        packageName: OngoingSupportNames.buildYourOwn,
        getPrice: (number) => 0,
        calculatedPrice: 0,
        description: `Custom package to support unique needs.
                        The price depends on your location. Please continue so we can get your contact details.`,
        recommended: false,
        paymentFrequency: PaymentFrequency.Monthly,
    },
];

export type POSSolutionNames =
    | "WelcomePOS"
    | "StorePOS"
    | "CarePOS"
    | "MediePOS"
    | "FlexePOS Bronze"
    | "FlexePOS Silver"
    | "FlexePOS Gold";

export interface POSSolution {
    POSSolutionName: POSSolutionNames;
    POSSolutionLogo: string;
    industries: Industries[];
    description: string;
    getEPOSLicencePrice: (deviceCounter: number) => number;
    getTerminalsLicencePrice: (terminalsCounter: number) => number;
    terminalLicencePrice: number;
    paymentFrequency: PaymentFrequency;
    keyFeatureQuestions: KeyFeatureQuestions[] | null;
}

export enum KeyFeatureQuestions {
    ManageMultipleSites = "Will you be managing multiple business locations?",
    ImportExportProducts = "Do you need to import/export products to/from your system?",
    ConfigurableProductBrowser = "Do you prefer a configurable product browsing experience?",
    WeightAndLiquidProductManagement = "Do you deal with weight and liquid product management?",
    StockManagement = "Is efficient stock management a priority for your business?",
    MultiplePriceLists = "Would you like to set up multiple price lists?",
    SecondaryPrinterOrderReceipts = "Do you need additional printers for order receipts?",
    CustomerFacingDisplayManagement = "Will you use a customer-facing display for transactions?",
    SuspendTransactions = "Do you need the ability to suspend transactions?",
    TabManagement = "Will you be managing tabs or open orders?",
    ConfigurableCRM = "Do you require a configurable Customer Relationship Management (CRM) system?",
    AppointmentBooking = "Will you be managing appointments or booking through the system?",
    SMSReminders = "Do you want to send SMS booking reminders or messages to customers?",
    CommissionReports = "Is commission tracking important for your business?",
    ProductModifiers = " Do you need to apply modifiers to your products menu? Item Modifiers edit, modify or specify to the kitchen a change to a pre-existing item. Modifiers can also add to the cost of the item if necessary. For example: extra avocado for 0.75, no mushrooms.",
    StaffTimeKeeping = "Do you require staff timekeeping functionality?"
}


export const POSSolutions: POSSolution[] = [
    {
        POSSolutionName: "WelcomePOS",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/WELCOMEPOS.jpg",
        industries: [
            Industries.Bakery,
            Industries.PubBar,
            Industries.Restaurant,
            Industries.SmallCoffee,
            Industries.Hotels,
        ],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 12 : 35),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 12 : 35),
        terminalLicencePrice: 12,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: null,
    },
    {
        POSSolutionName: "StorePOS",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/STOREPOS.jpg",
        industries: [Industries.Convenience, Industries.Store],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 30 : 46),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 18 : 46),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: null,
    },
    {
        POSSolutionName: "CarePOS",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/CAREPOS.jpg",
        industries: [
            Industries.Hairdresser,
            Industries.Barber,
            Industries.Spa,
            Industries.NailTechnician,
        ],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 30 : 46),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 18 : 46),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: null,
    },
    {
        POSSolutionName: "MediePOS",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/MEDIEPOS.jpg",
        industries: [Industries.Doctor, Industries.Dentist, Industries.Lab],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 30 : 46),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 18 : 46),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: null,
    },
    {
        POSSolutionName: "FlexePOS Bronze",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/FLEXEPOS-BRONZE.jpg",
        industries: [Industries.Custom],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 15 : 15),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 15 : 15),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: [],
    },
    {
        POSSolutionName: "FlexePOS Silver",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/FLEXEPOS-SILVER.jpg",
        industries: [Industries.Custom],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 20 : 31),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 18 : 31),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: [
            KeyFeatureQuestions.ManageMultipleSites,
            KeyFeatureQuestions.ImportExportProducts,
            KeyFeatureQuestions.ConfigurableProductBrowser,
            KeyFeatureQuestions.WeightAndLiquidProductManagement,
            KeyFeatureQuestions.StockManagement,
            KeyFeatureQuestions.MultiplePriceLists,
            KeyFeatureQuestions.SecondaryPrinterOrderReceipts,
            KeyFeatureQuestions.CustomerFacingDisplayManagement,
        ],
    },
    {
        POSSolutionName: "FlexePOS Gold",
        POSSolutionLogo: "https://npi.ie/wp-content/uploads/2024/01/FLEXEPOSGOLD.jpg",
        industries: [Industries.Custom],
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam placerat justo nec maximus bibendum.`,
        getEPOSLicencePrice: (deviceCounter) => (deviceCounter >= 2 ? 30 : 46),
        getTerminalsLicencePrice: (terminalsCounter) => (terminalsCounter >= 2 ? 18 : 46),
        terminalLicencePrice: 18,
        paymentFrequency: PaymentFrequency.Monthly,
        keyFeatureQuestions: [
            KeyFeatureQuestions.ManageMultipleSites,
            KeyFeatureQuestions.ImportExportProducts,
            KeyFeatureQuestions.ConfigurableProductBrowser,
            KeyFeatureQuestions.WeightAndLiquidProductManagement,
            KeyFeatureQuestions.StockManagement,
            KeyFeatureQuestions.MultiplePriceLists,
            KeyFeatureQuestions.SecondaryPrinterOrderReceipts,
            KeyFeatureQuestions.CustomerFacingDisplayManagement,
            KeyFeatureQuestions.SuspendTransactions,
            KeyFeatureQuestions.TabManagement,
            KeyFeatureQuestions.ConfigurableCRM,
            KeyFeatureQuestions.AppointmentBooking,
            KeyFeatureQuestions.SMSReminders,
            KeyFeatureQuestions.CommissionReports,
            KeyFeatureQuestions.ProductModifiers,
            KeyFeatureQuestions.StaffTimeKeeping,
        ],
    },
];
